<template>
    <div>
        <menuVar></menuVar>
        <!-- <div class="itemSlide"> -->
        <div class="mt-3">
            <!--  <img src="vistas/dist/custom/imgs/home.png" class="imgEquipoLog" data-aos="fade-right" data-aos-duration="1500"> -->
            <div
                class="container pb-4 d-flex flex-column flex-lg-row justify-content-center align-items-center align-items-md-center align-items-end ">
                <div class="item d-flex flex-column  justify-content-center">

                    <div class="d-flex align-items-center flex-column">
                        <h1 class="titleSlide text-center  mt-5" >¡Ser un
                            socio ChevronCard te da beneficios!</h1>
                        <h2 class="titleSlide text-center  mb-0 mt-3" >
                            REGISTRAR USUARIO</h2>
                        <img class="img-fluid imgLogin m-auto d-flex " src="../img/Recurso 74.png" data-aos="zoom-in"  data-aos-duration="2000">
                    </div>

                    <span class="titleSlideAdvertensia text-center  mt-5">
                        Página en mantenimiento, en breve se restablecerá el servicio, estamos trabajando para 
                        ofrecer mejores beneficios, sigue acumulando con tu Chevron Card !!!!


                    </span>
  

                </div>
            </div>

        </div>

        <b-modal size="md" style="color: #003149;" title="Registrar Usuario" v-model="modalPerfil" hide-footer>
            <b-container>
                <div style="display: flex;">
                    <div style="width: 40%; ">
                        <b-form-group class="mt-1 " style="font-size: 12px;" label="Usuario (# Telefono):"
                            label-for="usuarioInput">
                            <b-form-input size="sm" style="font-size: 16px;" id="usuarisoInput"
                                v-model="datosUsuario.usuario" name="usuario" type="number" onKeyPress="if(this.value.length==10) return false;" required >
                            </b-form-input>
            
                        </b-form-group>

                    </div>
                    <div style="width: 60%;display: flex;">

                        <b-form-group class="mt-1 ml-1" style="font-size: 12px;" label="Contraseña:"
                            label-for="passInput">
                            <b-form-input size="sm" style="font-size: 16px;" id="passInput" v-model="datosUsuario.pass"
                            maxlength="8"  min="2" :type="showPassword ? 'text' : 'password'">
                            </b-form-input>

                        </b-form-group>
                        <button class="input-group-text" style="max-height: 30px; margin-top: 30px;" @click="sbMostrarPass" >
                                    <span v-if="showPassword" class="fas fa-eye-low-vision"></span>
                                    <span v-else class="fas fa-eye"></span>
                                </button>
              
                    </div>
                </div>

                <b-form-group class=" ml-1" style="font-size: 12px;" label="Nombre Usuario:" label-for="nombreInput">
                    <b-form-input size="sm" style="font-size: 16px;" id="nombreInput" type="text"
                        v-model="datosUsuario.nombreUsuario" maxlength="40">
                    </b-form-input>
                </b-form-group>
                <b-form-group class="ml-1" style="font-size: 12px;" label="Correo:" label-for="correoInput">
                    <b-form-input size="sm" style="font-size: 16px;" id="correoInput" type="email"
                        v-model="datosUsuario.correo" maxlength="90">
                    </b-form-input>
                </b-form-group>

                <button class="btnAceptar1 mt-4" @click="sbGuardarUsuario" style="width: 100%;"> Guardar
                </button>

            </b-container>
        </b-modal>

    </div>

</template>

<script>
import servicioCliente from '../services/servicioCliente'
import menuVar from '../components/navBar.vue'
export default {
    components: {
        menuVar
    },
    data() {
        return {
            facturar: false,
            activacion: [],
            codigoActivacion: '',
            modalPerfil: false,
            datosUsuario: {
                usuario: '',
                pass: '',
                nombreUsuario: '',
                clienteID: 0,
                numeroCliente: '',
                rfc: '',
                nombre: '',
                calle: '',
                colonia: '',
                ciudad: '',
                codigoPostal: '',
                noInterior: '',
                noExterior: '',
                localidad: '',
                estado: '',
                regimenFiscalID: 1,
                descripcion: '',
                correo: ''

            },
            clienteID: 0,
            numeroCliente: '',
            idRegimen: null,
            show:false,
            showPassword:false

        }
    },
    methods:
    {
        async sbGuardarUsuario() {
            var mensaje = ''
            if (this.datosUsuario.usuario.length < 10) {
                mensaje = 'El usuario  debe de ser de 10 digitos'
                this.$msg.warning(mensaje)
                return
            }

            if (this.datosUsuario.usuario.length > 10) {
                mensaje = 'El usuario debe de ser de 10 digitos'
                this.$msg.info(mensaje)
                return
            }

            if (this.datosUsuario.pass.toString().trim() == "") {
                mensaje = 'La contraseña no debe de estar en blanco'
                this.$msg.info(mensaje)
                return
            }

            if (this.datosUsuario.nombreUsuario.toString().trim() == "") {
                mensaje = 'El nombre de usuario no debe de estar en blanco'
                this.$msg.info(mensaje)
                return
            }

            if (this.datosUsuario.usuario.substring(0,8).toString() == this.datosUsuario.pass)
            {
                mensaje = 'EL usuario es muy similar a su contraseña , favor de cambiar.'
                this.$msg.info(mensaje)
                return
            }

            if (this.datosUsuario.correo.toString().trim() == "") {
                mensaje = 'El correo no debe de estar en blanco, este dato es importante para poder recuperar su contraseña!!.'
                this.$msg.info(mensaje)
                return
            }

            if (!(this.sbValidEmail(this.datosUsuario.correo.toString())))
            {
                mensaje = 'El correo debe de ser valido !!.'
                this.$msg.info(mensaje)
                return
            }
            

            var respuestaUsuario = await servicioCliente.existeNoUsuario(this.datosUsuario.usuario)
            if (respuestaUsuario.data.length > 0) {
                if (respuestaUsuario.data[0].respuesta == "Usuario ya registrado") {
                    mensaje = 'Usuario ya registrado'
                    this.$msg.info(mensaje)
                    return
                }
            }

            this.datosUsuario.clienteID = this.clienteID
            this.datosUsuario.numeroCliente = this.numeroCliente
            this.datosUsuario.idRegimen = this.idRegimen;

            var respuesta = await servicioCliente.activarTarjeta(this.datosUsuario)
            if (respuesta.value == true) {
                mensaje = 'Tarjeta Activada Exitosamente.'
                this.$msg.success(mensaje)
                this.numeroCliente =""
                this.codigoActivacion=""
                this.modalPerfil = false

            }
            else {

                mensaje = 'No se pudo activar la tarjeta.. favor de contactar al Servicio al Cliente.'
                this.$msg.error(mensaje)

            }

        },
        sbMostrarPass()
        {
            if(this.showPassword)
        {this.showPassword=false}
        else
        {this.showPassword=true}
        },
        sbLimpiar(){
            this.datosUsuario = {
                usuario: '',
                pass: '',
                nombreUsuario: '',
                clienteID: 0,
                numeroCliente: '',
                rfc: '',
                nombre: '',
                calle: '',
                colonia: '',
                ciudad: '',
                codigoPostal: '',
                noInterior: '',
                noExterior: '',
                localidad: '',
                estado: '',
                regimenFiscalID: 1,
                descripcion: '',
                correo: ''

            }        },

        sbLogin() {
            this.$router.push({ name: "loginV" });
        },

        async sbActivacion() {
            var mensaje = ''
            this.show= true
            this.sbLimpiar()

            if (this.numeroCliente.toString().trim() == "") {
                mensaje = 'Falta el numero de cliente'
                this.$msg.info(mensaje)
                this.show= false
                return
            }

            if (this.codigoActivacion.toString().trim() == "") {
                mensaje = 'Falta el codigo de activacion'
                this.show= false
                this.$msg.info(mensaje)
                return
            }

            var respuesta = await servicioCliente.datosActivacion(this.numeroCliente, this.codigoActivacion)

            if (respuesta.value == true) {
                this.activacion = respuesta.data

                if (this.activacion.length > 0) {

                    if (this.activacion[0].estatus == '0') {
                        this.clienteID = this.activacion[0].clienteID
                        this.numeroCliente = this.activacion[0].numeroCliente
                        this.modalPerfil = true

                    }
                    else {
                        mensaje = this.activacion[0].mensaje
                        this.$msg.info(mensaje)
                    }
                }
                else {
                    mensaje = 'No se encontro información de la tarjeta.'
                    this.$msg.info(mensaje)
                }
            }
            else {
                this.$msg.info(respuesta.message)

            }
            this.show= false
        },

        sbValidEmail: function (email) {
            var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return regex.test(email);
    }
    }

}
</script>

<style>
.tituloEt:hover {
    cursor: pointer;
}

.estiloMensaje {
    font-size: 16px;
    text-align: center;;
}

</style>